import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { useHistory, useParams } from 'react-router';
import { Route } from 'react-router-dom';
import useSWR from 'swr';
import { IssueType } from '../../../../../../../../typings/Issue.interface';
import { APIIssueTrigger } from '../../../../../../../../typings/IssueTrigger.interface';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { issue_type_configs } from '../../../../../utils/issues';
import Divider from '../../../../common/base/Divider';
import Loading from '../../../../common/base/Loading';
import Tabs from '../../../../common/base/Tabs';
import Text from '../../../../common/base/Text';
import { EmptyResults, StyledEmptyStateWrapper } from '../../../../common/EmptyState';
import { Div } from '../../../../common/helpers/StyledUtils';
import Modal from '../../../../common/Modal';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { TeamPermission } from '../../../../contexts/TeamPermissionContext';
import { IssueTriggersRenderData } from './';
import issue_trigger_forms from './Forms/IssueTriggersForms';
import IssueTriggerCard from './IssueTriggerCard';
const IssueTriggersGroup: React.FC<{
  type: IssueType;
  issue_triggers: APIIssueTrigger[];
  render_data: IssueTriggersRenderData;
  onIssueTriggerCreated: () => void;
}> = t0 => {
  const $ = _c(14);
  const {
    type,
    issue_triggers,
    render_data,
    onIssueTriggerCreated
  } = t0;
  let t1;
  if ($[0] !== issue_triggers || $[1] !== render_data) {
    let t2;
    if ($[3] !== render_data) {
      t2 = issue_trigger => <IssueTriggerCard key={issue_trigger.id} issue_trigger={issue_trigger} render_data={render_data} />;
      $[3] = render_data;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = issue_triggers.map(t2);
    $[0] = issue_triggers;
    $[1] = render_data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== issue_triggers.length) {
    t2 = issue_triggers.length === 0 && <StyledEmptyStateWrapper><EmptyResults label="No issue triggers found" /></StyledEmptyStateWrapper>;
    $[5] = issue_triggers.length;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== onIssueTriggerCreated || $[8] !== type) {
    t3 = <Route path="/issue-triggers/:type/create/:createtype" render={() => <CreateIssueTrigger type={type} onIssueTriggerCreated={onIssueTriggerCreated} />} />;
    $[7] = onIssueTriggerCreated;
    $[8] = type;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
const CreateIssueTrigger: React.FC<{
  type: IssueType;
  onIssueTriggerCreated: () => void;
}> = t0 => {
  const $ = _c(31);
  const {
    type: parent_type,
    onIssueTriggerCreated
  } = t0;
  const {
    addToast
  } = useToasts();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const history = useHistory();
  const {
    createtype: type
  } = useParams();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = APIMethodKeys.team_integrations.list();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== HookdeckAPI.team_integrations) {
    t2 = () => HookdeckAPI.team_integrations.list();
    $[1] = HookdeckAPI.team_integrations;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: integrations
  } = useSWR(t1, t2);
  const Fields = issue_trigger_forms[type].Fields;
  let t3;
  if ($[3] !== history || $[4] !== parent_type) {
    t3 = () => {
      history.push({
        pathname: `/issue-triggers/${parent_type}`,
        search: location.search,
        state: {
          scroll: false
        }
      });
    };
    $[3] = history;
    $[4] = parent_type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onClose = t3;
  if (integrations === undefined) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        justify: "center"
      };
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Div flex={t4} p={8}><Loading /></Div>;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  const t4 = issue_trigger_forms[type];
  let t5;
  if ($[8] !== integrations.models || $[9] !== t4) {
    t5 = t4.getInitialValues(integrations.models);
    $[8] = integrations.models;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = issue_trigger_forms[type];
  let t7;
  if ($[11] !== HookdeckAPI.issue_triggers || $[12] !== addToast || $[13] !== history || $[14] !== onIssueTriggerCreated || $[15] !== parent_type || $[16] !== type) {
    t7 = values => HookdeckAPI.issue_triggers.create(issue_trigger_forms[type].formatValuesToAPIInput(values as any)).then(issue_trigger => {
      addToast("success", "Created issue trigger");
      onIssueTriggerCreated();
      history.push({
        pathname: `/issue-triggers/${parent_type}`,
        search: location.search,
        state: {
          scroll: false
        }
      });
      return issue_trigger;
    }).catch(() => {
      addToast("error", "Error creating issue trigger");
      return null;
    });
    $[11] = HookdeckAPI.issue_triggers;
    $[12] = addToast;
    $[13] = history;
    $[14] = onIssueTriggerCreated;
    $[15] = parent_type;
    $[16] = type;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== Fields || $[19] !== history || $[20] !== integrations.models || $[21] !== onClose || $[22] !== parent_type || $[23] !== type) {
    t8 = t9 => {
      const {
        isSubmitting,
        isValid
      } = t9;
      return <Form><Modal size="medium" onCancel={onClose} onClose={onClose} handle_click_outside={_temp} cancel_label="Cancel" hide_close={true} submit_disabled={isSubmitting || !isValid} is_submitting={isSubmitting} submit_label="Create trigger" p={0}><Div><Text bold={true} size="l" p={{
              x: 4,
              y: 4
            }}>Create issue trigger</Text><Tabs tabs={Object.entries(issue_type_configs).map(_temp2)} onTabSelected={tab => {
              history.push(`/issue-triggers/${parent_type}/create/${tab}`);
            }} compact={true} tab_radio={true} border={false} active_tab={type} p={{
              x: 4
            }} /><Divider /><Div p={4}><Fields integrations={integrations.models} muted={true} /></Div></Div></Modal></Form>;
    };
    $[18] = Fields;
    $[19] = history;
    $[20] = integrations.models;
    $[21] = onClose;
    $[22] = parent_type;
    $[23] = type;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t5 || $[26] !== t6.validate || $[27] !== t7 || $[28] !== t8 || $[29] !== type) {
    t9 = <TeamPermission role="member"><Formik key={type} initialValues={t5} validate={t6.validate} onSubmit={t7}>{t8}</Formik></TeamPermission>;
    $[25] = t5;
    $[26] = t6.validate;
    $[27] = t7;
    $[28] = t8;
    $[29] = type;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
export default IssueTriggersGroup;
function _temp() {}
function _temp2(t0) {
  const [key, config] = t0;
  return {
    label: config.label,
    key
  };
}